/**
 * Plus Icon Component
 * Reusable SVG icon for add/create actions
 */
import React from "react";
import PropTypes from "prop-types";

const PlusIcon = ({
  size = 18,
  color = "currentColor",
  className = "",
  ...props
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path d="M11 5v6H5v2h6v6h2v-6h6v-2h-6V5h-2z" fill={color} />
    </svg>
  );
};

PlusIcon.propTypes = {
  size: PropTypes.number,
  color: PropTypes.string,
  className: PropTypes.string,
};

export default PlusIcon;
